import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton, ResponsiveDialog, Stack, Text, TextArea, TextInput } from 'shell/components';

const AddCriterionDialog = ({ open, onClose, onSave }) => {
    const { t } = useTranslation('assignment');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (!open) {
            setTimeout(() => {
                setTitle('');
                setDescription('');
            }, 150);
        }
    }, [open]);

    return (
        <ResponsiveDialog aria-labelledby={'dialog-title'} open={open} onClose={onClose}>
            <Stack sx={{ minWidth: '300px' }} spacing={4}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text id={'dialog-title'} component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('rubric.criterion-form.add-title', 'Add New Criterion')}
                    </Text>
                    <IconButton
                        aria-label={'close'}
                        kind={'exit'}
                        size={'medium'}
                        variant={'square'}
                        onClick={onClose}
                    />
                </Stack>
                <TextInput
                    autoFocus
                    label={t('rubric.criterion-form.criterion-label', 'Name')}
                    placeholder={t('rubric.criterion-form.criterion-placeholder', 'Enter criterion name')}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <TextArea
                    label={t('rubric.criterion-form.description-label', 'Description')}
                    placeholder={t('rubric.criterion-form.description-placeholder', 'Enter criterion description')}
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
                <Button sx={{ alignSelf: 'flex-end' }} onClick={() => onSave(title.trim(), description.trim())}>
                    {t('common:controls.save', 'Save')}
                </Button>
            </Stack>
        </ResponsiveDialog>
    );
};

export default AddCriterionDialog;
